import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { EmptyState, PageHeader } from '@koyomi/ui';

/** Rota que a API só libera para admin: o usuário padrão vê um aviso amigável em vez de erros 403 soltos. */
export function ForbiddenPage() {
  const { t } = useTranslation(['nav', 'common']);
  return (
    <>
      <PageHeader title={t('nav:forbidden.title')} />
      <EmptyState title={t('nav:forbidden.title')} description={t('nav:forbidden.description')} action={<Link className="k-btn k-btn--secondary" to="/agenda">{t('nav:main.myAgenda')}</Link>} />
    </>
  );
}
